<template>
  <div class="inling-goal-list">

    <div class="goal-category__header">
      <!-- <h3 class="m-0">{{category.name}}</h3> -->

      <h5 class="m-0 p-2">
        <!-- {{categoryName}} -->
        <inline-editable-text
          @change="onUpdateCategoryName"
          :value="categoryName"
          :resetOnCancel="false"
          :inline="true"  />
      </h5>

      <el-popover>
        <el-button slot="reference" plain size="small" class="text-right">
          <font-awesome-icon size="1x" :icon="['fas', 'plus-circle']"/>
          {{addCardText}}
        </el-button>

        <h5>Create Abstract Goal</h5>
        <el-button @click="onAdd">
          Add Goal
        </el-button>

        <hr />

        <h5>Create Action Goal</h5>
        <div style="display: flex; flex-wrap: wrap; justify-content: space-around;">
          <el-button
            v-for="type in commitment_types"
            :key="type.id"
            :disabled="type.disabled"
            @click.prevent="onOpenCommitmentWizard(type.id)"
            size="fat"
            style="width: 90px; height: 120px; font-size: 6.5pt"
            class="fat-checkbox m-0 p-0 pt-1 mr-2">
            <img class="fat-checkbox__image" :src="type.src" height="48" />
            <div class="fat-checkbox__text hide-when-small">{{type.text}}</div>
          </el-button>
        </div>
      </el-popover>
    </div>

    <!--
      :forceFallback="true"
    -->
    <draggable
      :scroll="true"
      :scrollSensitivity="0"
      :animation="0"
      class="clearfix"
      v-model="draggablesList"
      ref="draglist"
      draggable=".item"
      :setData="() => {}"
      :disabled="false"
      :group="'goals'"
      :move="() => {}">

      <InlineGoalCardMinimal
        class="item"
        ref="items"
        v-for="element in draggablesList"
        :key="element.$key"
        :goal="element"
        @click.native="onClickGoalCard( element.$id )">
      </InlineGoalCardMinimal>

    </draggable>

    <!-- <pre class="mini-pre">VALUE: {{value}}</pre> -->
  </div>
</template>

<script>
import Draggable from 'vuedraggable';
import util from '@/util'
import { COMMITMENT_TYPES } from '@/components/Config/types.js'

export default {
  props: {
    value: {},
    listId: {},
    listIdParam: { default: null },
    addCardText: { default: "New Goal" },
    categoryName: {},
    categoryId: {},
  },
  data() {
    return {
      commitment_types: COMMITMENT_TYPES,
    }
  },
  computed: {
    draggablesList: {
      get() {
        return this.value;
      },
      set(items) {
        /* Check for foreign items */
        const [ foreignItems, regularItems ] = util.partition( items, item => {
          return ( item[ this.listIdParam ] || null ) !== this.listId
        })

        console.log("[" + this.listId + "]", "foreignItems", foreignItems);
        this.$emit('list-move', foreignItems)

        console.log("[" + this.listId + "]", "regularItems", regularItems);
        if ( regularItems.length !== 0 ) {
          this.$emit('list-reorder', regularItems)
        }
      }
    },
  },
  methods: {

    onClickGoalCard( goalId ) {
      this.$emit('select', goalId)
    },

    onAdd() {
      this.$emit('item-add')
    },

    onOpenCommitmentWizard( goalId = 'TODO', type = null ) {
      this.$root.showNewModal('effort', {
        goalId: goalId,
        type: type,
        tscId: null,
        showWizard: true
      });
    },

    onUpdateCategoryName( value ) {
      this.$models.userGoalCategory.update( this.categoryId, {
        name: value
      })
    },
  },
  components: {
    Draggable,
  }
};
</script>

<style>
</style>
